document.addEventListener('DOMContentLoaded', () => {
  /* =========================
     Guard : exécute uniquement sur la page register
     ========================= */
  const privateForm = document.getElementById('CreateCustomerForm');
  const privateSubmit = document.getElementById('RegisterSubmit');

  const email = document.getElementById('RegisterForm-email');
  const password = document.getElementById('RegisterForm-password');

  const emailErr = document.getElementById('RegisterForm-email-client-error');
  const passErr = document.getElementById('RegisterForm-password-client-error');

  if (!privateForm || !privateSubmit || !email || !password) return;

  /* =========================
     Helpers
     ========================= */
  function setFieldError(inputEl, errorEl, message) {
    if (!inputEl || !errorEl) return;

    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      inputEl.removeAttribute('aria-invalid');
      return;
    }

    errorEl.textContent = message;
    errorEl.hidden = false;
    inputEl.setAttribute('aria-invalid', 'true');
  }

  function msg(el, key, fallback = '') {
    return (el?.dataset && el.dataset[key]) ? el.dataset[key] : fallback;
  }

  function isValidEmail(v) {
    const s = (v || '').trim();
    return s.length > 3 && s.includes('@') && s.includes('.');
  }

  function validatePrivate() {
    const e = (email.value || '').trim();
    const p = password.value || '';

    let ok = true;

    // Email
    if (!e) {
      setFieldError(email, emailErr, msg(emailErr, 'required', "Veuillez renseigner votre adresse e-mail"));
      ok = false;
    } else if (!isValidEmail(e)) {
      setFieldError(email, emailErr, msg(emailErr, 'invalid', "Adresse e-mail invalide"));
      ok = false;
    } else {
      setFieldError(email, emailErr, '');
    }

    // Password
    if (!p) {
      setFieldError(password, passErr, msg(passErr, 'required', "Veuillez choisir un mot de passe"));
      ok = false;
    } else if (p.length < 5) {
      setFieldError(password, passErr, msg(passErr, 'tooShort', "Le mot de passe doit contenir au moins 5 caractères"));
      ok = false;
    } else {
      setFieldError(password, passErr, '');
    }

    privateSubmit.disabled = !ok;
    return ok;
  }

  /* =========================
     Events
     ========================= */
  email.addEventListener('input', validatePrivate);
  email.addEventListener('change', validatePrivate);
  password.addEventListener('input', validatePrivate);
  password.addEventListener('change', validatePrivate);

  privateForm.addEventListener('submit', (e) => {
    const ok = validatePrivate();
    if (!ok) {
      e.preventDefault();
      if (emailErr && !emailErr.hidden) email.focus();
      else if (passErr && !passErr.hidden) password.focus();
    }
  });

  // Init
  validatePrivate();
});
